<template>
	<n-card
		:title
		:size
		:bordered
		:embedded
		:content-class="`size-full ${contentClass || ''}`"
		:segmented
		:hoverable
		:header-class
		:header-extra-class
		:action-class
		:footer-class
		:cover-class
		:class="`jm-card jm-card-${size || 'medium'} ${type ? `jm-card-${type}` : ''}`"
	>
		<template v-if="$slots.header" #header>
			<slot name="header" />
		</template>
		<template v-if="$slots['header-extra']" #header-extra>
			<slot name="header-extra" />
		</template>
		<template v-if="$slots.action" #action>
			<slot name="action" />
		</template>
		<template v-if="$slots.footer" #footer>
			<slot name="footer" />
		</template>
		<template v-if="$slots.cover" #cover>
			<slot name="cover" />
		</template>
		<template v-if="$slots.default" #default>
			<slot />
			<Transition name="jm-card-loading-fade" mode="out-in">
				<div
					v-if="loading"
					class="loading-overlay absolute inset-0 flex items-center justify-center bg-white/50"
				>
					<n-spin :show="loading" />
				</div>
			</Transition>
		</template>
	</n-card>
</template>

<script setup lang="ts">
import type { CardSize } from "naive-ui"
import { NCard, NSpin } from "naive-ui"

defineProps<{
	title?: string
	size?: CardSize
	bordered?: boolean
	embedded?: boolean
	contentClass?: string
	loading?: boolean
	hoverable?: boolean
	segmented?: boolean
	headerClass?: string
	headerExtraClass?: string
	actionClass?: string
	footerClass?: string
	coverClass?: string
	type?: "primary"
}>()
</script>

<style lang="scss" scoped>
.jm-card-small {
	border-radius: var(--card-radius-small);

	.loading-overlay {
		border-radius: var(--card-radius-small);
	}
}
.jm-card-medium {
	border-radius: var(--card-radius-medium);

	.loading-overlay {
		border-radius: var(--card-radius-medium);
	}
}
.jm-card-large {
	border-radius: var(--card-radius-large);

	.loading-overlay {
		border-radius: var(--card-radius-large);
	}
}
.jm-card-huge {
	border-radius: var(--card-radius-huge);

	.loading-overlay {
		border-radius: var(--card-radius-huge);
	}
}

.jm-card-loading-fade-enter-active,
.jm-card-loading-fade-leave-active {
	transition: opacity 0.2s ease-in-out;
}

.jm-card-loading-fade-enter-from,
.jm-card-loading-fade-leave-to {
	opacity: 0;
}

.jm-card-primary {
	border: 1px solid var(--primary-color) !important;
	overflow: hidden;

	:deep() {
		.n-card-header {
			background-color: var(--primary-200-color);

			.n-card-header__main {
				color: var(--primary-700-color);
			}
		}
	}
}
</style>
